import Fetcher from "./FetchService";
class ProfilePhotoService {
}
ProfilePhotoService.getProfilePhotoCurrentStatus = (props) => Fetcher.getSingleResponse("/aviso/ProfilePhoto/retrievePhotoUploadStatus", props);
export default ProfilePhotoService;
